import { ALLOWED_ANDROID_CALLBACK_SCHEMES, ALLOWED_HOSTS, ANDROID_SCHEME_CALLBACK_PATH, androidSchemeHostToProvider, webCallbackPathToProvider } from '../../shared/oauth-config';
export { ALLOWED_HOSTS, ANDROID_SCHEME_CALLBACK_PATH, OAUTH_CALLBACK_PATHS, androidCallbackHost } from '../../shared/oauth-config';
const MAX_AUTH_TOKEN_LENGTH = 4096;
const MIN_AUTH_TOKEN_LENGTH = 16;
const MAX_STATE_LENGTH = 256;
const MAX_ERROR_LENGTH = 256;
function resolveCallbackProvider(url) {
    if (url.protocol === 'https:') {
        return ALLOWED_HOSTS.includes(url.host) ? webCallbackPathToProvider(url.pathname) : null;
    }
    if (ALLOWED_ANDROID_CALLBACK_SCHEMES.includes(url.protocol.slice(0, -1))) {
        return url.pathname === ANDROID_SCHEME_CALLBACK_PATH ? androidSchemeHostToProvider(url.host) : null;
    }
    return null;
}
export function isOAuthCallbackUrl(rawUrl) {
    try {
        return resolveCallbackProvider(new URL(rawUrl)) != null;
    } catch (unused) {
        return false;
    }
}
export function parseOAuthCallback(rawUrl) {
    var _fragment_get;
    let url;
    try {
        url = new URL(rawUrl);
    } catch (unused) {
        return {
            kind: 'ignored'
        };
    }
    const provider = resolveCallbackProvider(url);
    if (provider == null) {
        return {
            kind: 'ignored'
        };
    }
    const fragment = new URLSearchParams(url.hash.slice(1));
    const error = fragment.get('error');
    if (error != null && error.length <= MAX_ERROR_LENGTH) {
        return {
            kind: 'error',
            provider,
            error
        };
    }
    if (error != null) {
        return {
            kind: 'ignored'
        };
    }
    const state = (_fragment_get = fragment.get('state')) !== null && _fragment_get !== void 0 ? _fragment_get : '';
    if (state.length > MAX_STATE_LENGTH) {
        return {
            kind: 'ignored'
        };
    }
    const authToken = fragment.get('authToken');
    const isPlausibleToken = authToken != null && authToken.length >= MIN_AUTH_TOKEN_LENGTH && authToken.length <= MAX_AUTH_TOKEN_LENGTH;
    if (isPlausibleToken) {
        return {
            kind: 'success',
            provider,
            authToken,
            state
        };
    }
    return {
        kind: 'ignored'
    };
}
